import { useState } from "react"

const FTABtn = ({domain}) => {
    const [open, setOpen] = useState(false);
    const [err, setErr] = useState(false);
    const [list, setList] = useState([]);
    const setMaskFetch = async () => {
        try {
            const responce = await fetch(`https://${domain}/api/packages/progs/FTA`);
            if(!responce.ok) throw new Error(responce.message);
            const data = await responce.json();
            setList(data?.progs);
            setErr(false);
            setOpen(true);
        } catch(e) {
            console.error(e);
            setErr(true);
        }
    }

    const handleClose = (isErr) => {
        isErr ? setErr(!err) : setOpen(!open);
    }

    return <>
        <button className='requestBtn' onClick={setMaskFetch}>FTA channels list</button>
        {open &&         
            <div className='modal-window'>
                <div className='modal-box programs'>
                    <h2>List of programs</h2>
                    <h3 style={{textAlign: 'center', color: "#1565C0"}}>FTA</h3>
                    <ul>{list.map(program => <li>{program}</li>)}</ul>
                
                </div>
                <button className='requestBtn' onClick={() => {handleClose(false)}}>Close</button>
            </div>
        }
        {err &&         
            <div className='modal-window'>
                <div className='modal-box programs'>
                    <h2>Poblem occured</h2>                
                </div>
                <button className='requestBtn' onClick={() => {handleClose(true)}}>Close</button>
            </div>
        }
    </>
}

export default FTABtn;